/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_View_ProductInputs */

const en_directory_hubs_view_product = /** @type {(inputs: Directory_Hubs_View_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View product`)
};

const zh_directory_hubs_view_product = /** @type {(inputs: Directory_Hubs_View_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看产品`)
};

/**
* | output |
* | --- |
* | "View product" |
*
* @param {Directory_Hubs_View_ProductInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_view_product = /** @type {((inputs?: Directory_Hubs_View_ProductInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_View_ProductInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_view_product(inputs)
	return zh_directory_hubs_view_product(inputs)
});
export { directory_hubs_view_product as "directory.hubs.view_product" }